import { ExcelDatatableStatus } from './responses/excel-datatable-status.response';
import { Observable } from 'rxjs';
import { environment } from './../../../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExcelDatatableService {

  API_URL = environment.urlOms;
  // Me mencionaron que es fijo. Es importante que después cambie o se obtenga de otra forma
  authBasic = 'Basic c2VydmljZXM6MC49ajNEMnNzMS53Mjkt';

  constructor(private http: HttpClient) { }

  estadoExcel(id: string): Observable<ExcelDatatableStatus> {
    const headers = this.headers(); 
    return this.http.get<ExcelDatatableStatus>(`${this.API_URL}/excel_stream_status?id=${id}`, {headers});
  } 

  descargarExcel(id: string, excelPrefix: string) {
    const headers = this.headers();
    return this.http.get(this.API_URL + '/excel_stream_download?id=' + id + '&name=' + excelPrefix, {headers: headers, responseType: "arraybuffer",  observe: 'response'});
  }

  headers() {
    return this.API_URL.startsWith('http://192') ? {} :
     (new HttpHeaders()).append('Authorization', this.authBasic);
  }

}
